/**
 * Challenge entity – video challenge with title, category, duration, status.
 * Supports both legacy (exercise, expiresAt) and new (title, category, startDate, endDate, status) fields.
 */
export const CHALLENGE_CATEGORIES = ['powerLifter', 'strongman', 'bodyBuilder'];

export const CHALLENGE_CATEGORY_LABELS = {
  powerLifter: 'Powerlifter',
  strongman: 'Strongman',
  bodyBuilder: 'Bodybuilder',
};

export const CHALLENGE_STATUS = { active: 'active', completed: 'completed' };

export function createChallenge({
  id,
  title = '',
  description = '',
  category = '',
  startDate = null,
  endDate = null,
  status = 'active',
  creatorId = '',
  exercise = '',
  rules = null,
  reward = null,
  participants = [],
  expiresAt = null,
  createdAt = null,
  disabled = false,
  submissionCount = 0,
}) {
  return {
    id,
    title: title || '',
    description: description || '',
    category: category || '',
    startDate: startDate?.toDate?.() ?? startDate ?? null,
    endDate: endDate?.toDate?.() ?? endDate ?? null,
    status: status || 'active',
    creatorId: creatorId || '',
    exercise: exercise || '',
    // `rules` may arrive as a plain string (new) or a legacy object. Pass through either.
    rules: rules ?? null,
    reward: reward ?? null,
    participants: Array.isArray(participants) ? participants : [],
    expiresAt: expiresAt?.toDate?.() ?? expiresAt ?? null,
    createdAt: createdAt?.toDate?.() ?? createdAt ?? null,
    disabled: Boolean(disabled),
    submissionCount: Number(submissionCount) || 0,
  };
}

export function isChallengeActive(challenge) {
  if (!challenge) return false;
  if (challenge.disabled) return false;
  if (challenge.status === 'completed') return false;
  const end = challenge.endDate || challenge.expiresAt;
  if (end && new Date(end) < new Date()) return false;
  return true;
}
